import { defineComponent as _defineComponent } from 'vue'
import { PriceService } from "@/services/price-service"
import config from "../../config"
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import { chargerTypes, chargerTypesFromBackend } from "@/models/common"
import type { Connector } from "@/models/common"

interface ConnectorComponentProps {
  connector: Connector
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectorComponent',
  props: {
    connector: { default: () => ({
    id: "",
    type: "",
    status: "",
    power: undefined
  }) }
  },
  emits: ["clicked"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const emit = __emit

const i18n = useI18n()

const classType = computed(() => {
  return props.connector.status === "AVAILABLE"
    ? "charger__left--available"
    : "charger__left--not-available"
})

const price = computed(() => {
  return PriceService.getPriceLabel(props.connector.price, i18n)
})

const connectorTypeSlug = computed(() => {
  const connectorType = props.connector.connectorType
  return connectorType ? chargerTypesFromBackend[connectorType] : "type2"
})

const connectorTypeName = computed(() => {
  return chargerTypes[connectorTypeSlug.value] ?? chargerTypes.type2
})

const connectorClicked = () => {
  if (props.connector.status === "AVAILABLE") {
    emit("clicked", props.connector)
  }
}

const __returned__ = { props, emit, i18n, classType, price, connectorTypeSlug, connectorTypeName, connectorClicked, get PriceService() { return PriceService }, get config() { return config }, computed, get useI18n() { return useI18n }, get chargerTypes() { return chargerTypes }, get chargerTypesFromBackend() { return chargerTypesFromBackend } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})